<template>
  <v-card class="mx-auto" flat>
    <v-container>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Data Instansi (yang ada di CV saat pendaftaran)</h3>
        <base-form-generator :schema="instansiDaftar" v-model="form" />
      </div>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Data Instansi (saat ini)</h3>
        <base-form-generator :schema="instansiSekarang" v-model="form" />
      </div>
      <div class="pa-5">
        <h3 class="indigo--text mb-4">Data Instansi (induk)</h3>
        <base-form-generator :schema="instansiInduk" v-model="form" />
      </div>
    </v-container>
  </v-card>
</template>

<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import SchemaInstansi from '../schema/instansi';

export default {
  name: 'FormInstansi',
  components: { BaseFormGenerator },
  mixins: [SchemaInstansi],
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});
    },

    initForm(value) {
      if (!value) return;

      const profil = [...this.instansiSekarang, ...this.instansiInduk];
      for (const item of profil) {
        if (item.name) {
          this.$set(this.form, item.name, value[item.name] === null ? null : value[item.name]);
        }
      }

      if (this.form.k_beda_instansi_psp === 51001) {
        this.$set(this.form, 'instansi_k_propinsi', this.$getDeepObj(value, 'instansi_k_propinsi') || '');
        this.$set(this.form, 'instansi_k_kota', this.$getDeepObj(value, 'instansi_k_kota') || '');
      }

      if (this.form.k_beda_tugas_psp === 51001) {
        this.$set(this.form, 'tugas_k_propinsi', this.$getDeepObj(value, 'tugas_k_propinsi') || '');
        this.$set(this.form, 'tugas_k_kota', this.$getDeepObj(value, 'tugas_k_kota') || '');
      }
    },

    getValue() {
      let params = Object.assign({}, this.form);

      if (params.k_beda_instansi_psp !== 51001) {
        delete params['instansi_nama'];
        delete params['instansi_alamat'];
        delete params['instansi_situs'];
        delete params['instansi_k_kota'];
        delete params['instansi_k_propinsi'];
      }

      if (params.k_beda_tugas_psp !== 51001) {
        delete params['tugas_nama'];
        delete params['tugas_alamat'];
        delete params['tugas_situs'];
        delete params['tugas_k_kota'];
        delete params['tugas_k_propinsi'];
      }

      return params;
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>

<style scoped></style>
